import React from "react";
import CalendarImg from "assets/icons/calendar.svg";
import { normalizeInput } from "helpers";
import "./style.scss";

type Props = {
  title: string;
  placeholder?: string;
  isAllowed: boolean;
  data: string;
	updateData: (val: string) => void;
};

export const ProfileInputPhone: React.FC<Props> = ({
  title,
  placeholder,
  isAllowed,
  data,
	updateData,
}) => {	

	const handleChange = ({ target: { value } }) => {
		updateData(normalizeInput(value))
  };

  return (
    <div className="profile-input-container">
      <span>{title}</span>
      <div className="profile-input">
        <input
          value={data != null ? data : ""}
          type="string"
          placeholder={placeholder}
          disabled={!isAllowed}
          onChange={handleChange}
        ></input>
        {title == "Birth date" && <img src={CalendarImg} alt="calendar" />}
      </div>
    </div>
  );
};
